const isArabicSite = !!$("html[lang='ar']").length;

function localize(mode = "autoTranslate", text) {
    if (mode == "returnValue" && !isArabicSite) {
        return text;
    }

    if (!isArabicSite) return;

    const colorsSearch = [
        {
            pathname: "/products/",
            selector: ".swatch-variant-name, .swatch-tool-tip-text",
            shouldClearInterval: false,
        }
    ];

    const translationData = [
        {
            searchIn: [
                {
                    pathname: "/ar/",
                    matchFullPath: true,
                    selector: "#insta-feed h2",
                    shouldClearInterval: true,
                },
                {
                    pathname: "/ar",
                    matchFullPath: true,
                    selector: "#insta-feed h2",
                    shouldClearInterval: true,
                }
            ],
            originalText: "Follow us on Instagram @One.of.a.kin",
            newText: "<span dir='ltr'>@One.of.a.kin</span> تابعونا على إنستغرام",
        },
        {
            searchIn: [
                {
                    pathname: "",
                    selector: ".tencel-hangtag",
                    shouldClearInterval: true,
                }
            ],
            originalText: "TENCEL™",
            newText: "<span dir='ltr'>TENCEL™</span>",
        },
        

        {
            searchIn: [{
                pathname: "/products/",
                selector: ".swatch-view-stack [name='Color'] + .swatch-option-name",
                shouldClearInterval: false,
            }],
            originalText: "Color",
            newText: "اللون",
        },
        {
            searchIn: colorsSearch,
            originalText: "Thunder Grey",
            newText: "رمادي الرعد",
        },
        {
            searchIn: colorsSearch,
            originalText: "Blue Sky",
            newText: "السماء الزرقاء",
        },
        {
            searchIn: colorsSearch,
            originalText: "Blue sky",
            newText: "السماء الزرقاء",
        },
        {
            searchIn: colorsSearch,
            originalText: "Creamy Dawn",
            newText: "الفجر الكريمي",
        },
        {
            searchIn: colorsSearch,
            originalText: "Sun Rays",
            newText: "أشعة الشمس",
        },
        {
            searchIn: colorsSearch,
            originalText: "Sun rays",
            newText: "أشعة الشمس",
        },
        {
            searchIn: colorsSearch,
            originalText: "Meadow Green",
            newText: "المرج الأخضر",
        },
        {
            searchIn: colorsSearch,
            originalText: "Touch of Sand",
            newText: "لمسة الرمال",
        },
        {
            searchIn: colorsSearch,
            originalText: "Blossom Pink",
            newText: "الزهر الوردي",
        },
        {
            searchIn: colorsSearch,
            originalText: "Lavender bud",
            newText: "برعم الخزامى",
        },
        {
            searchIn: colorsSearch,
            originalText: "Nocturnal",
            newText: "الليليّ",
        },
        {
            searchIn: colorsSearch,
            originalText: "Cherry Blush",
            newText: "حمرة الكرز",
        },
        {
            searchIn: colorsSearch,
            originalText: "Evergreen",
            newText: "دائمة الخضار",
        },
        {
            searchIn: [{
                pathname: "swym-wishlist",
                selector: ".swym-wishlist-add-to-cart-btn, .swym-add-to-cart-btn",
                shouldClearInterval: false,
                fullReplace: true
            }],
            originalText: "Add To Cart",
            newText: "أضف الى الحقيبة",
        },
        {
            searchIn: [{
                pathname: "swym-wishlist",
                selector: ".swym-wishlist-main-title",
                shouldClearInterval: false,
                fullReplace: true
            }],
            originalText: "My Wishlist",
            newText: "قائمة امنياتي",
        },
        {
            searchIn: [{
                pathname: "swym-wishlist",
                selector: ".swym-more-details-btn",
                shouldClearInterval: false,
                fullReplace: true
            }],
            originalText: "More Details",
            newText: "المزيد من التفاصيل",
        },
        {
            searchIn: [{
                pathname: "swym-wishlist",
                selector: ".swym-user-text",
                shouldClearInterval: false,
            }],
            originalText: "Guest Shopper",
            newText: "ضيف",
        },
        {
            searchIn: [{
                pathname: "swym-wishlist",
                selector: ".swym-back-btn",
                shouldClearInterval: false,
                fullReplace: true,
            }],
            originalText: "Back To List",
            newText: `<span aria-hidden="true"><span class="swym-icon"></span></span> الرجوع للقائمة`,
        },
        {
            searchIn: [{
                pathname: "swym-wishlist",
                selector: ".swym-wishlist-context-menu-item span",
                shouldClearInterval: false,
            }],
            originalText: "Clear List",
            newText: "امسح القائمة",
        },
        {
            searchIn: [{
                pathname: "swym-wishlist",
                selector: ".swym-empty-wishlist-title",
                shouldClearInterval: false,
                fullReplace: true,
            }],
            originalText: "Love It? Add To My Wishlist",
            newText: "اعجبتك؟ اضيفيها إلى قائمة الامنيات",
        },
        {
            searchIn: [{
                pathname: "swym-wishlist",
                selector: ".swym-empty-wishlist-text",
                shouldClearInterval: false,
                fullReplace: true,
            }],
            originalText: "you to keep track of all",
            newText: "تسمح لكم قائمة أمنياتي بتتبع كل اختياراتكم المفضلة وأنشطة التسوق الخاصة بكم سواء كنتم على جهاز الكمبيوتر أو الهاتف أو الجهاز اللوحي. لن تضطروا إلى إضاعة الوقت في البحث مجددًا عن القطعة التي أحببتوها على هاتفكم اليوم السابق - فكل شيء موجود هنا في مكان واحد.",
        },
        {
            searchIn: [{
                pathname: "swym-wishlist",
                selector: ".swym-empty-wishlist-continue-btn",
                shouldClearInterval: false,
                fullReplace: true,
            }],
            originalText: "Continue shopping",
            newText: "مواصلة التسوّق",
        },
        {
            searchIn: [
                {
                    pathname: "/collections/",
                    selector: ".swym-details",
                    shouldClearInterval: false,
                    fullReplace: true,
                },
                {
                    pathname: "/product/",
                    selector: ".swym-details",
                    shouldClearInterval: false,
                    fullReplace: true,
                }
            ],
            originalText: "has been added to",
            newText: "تمت الإضافة إلى قائمة رغباتك بنجاح",
        },
        {
            originalText: "Girls",
            newText: "للبنات",
        },
        {
            originalText: "Boys",
            newText: "للأولاد",
        },
        {
            originalText: "Boy",
            newText: "للأولاد",
        },
        {
            originalText: "Women",
            newText: "للنساء",
        },
        {
            originalText: "Men",
            newText: "للرجال",
        },
        {
            originalText: "Chill Shirt",
            newText: "تشيل شيرت",
        },
        {
            originalText: "Destress T-Shirt",
            newText: "ديسترس تيشيرت",
        },
        {
            originalText: "Destress T-shirt",
            newText: "ديسترس تيشيرت",
        },
        {
            originalText: "Midnight Top",
            newText: "بلوزة تانك مِد نايت",
        },
        {
            originalText: "Breezy Pants",
            newText: "سروال بريزي",
        },
        {
            originalText: "Unwind Shorts",
            newText: "أنوايند شورت",
        },
        {
            originalText: "Dreamland T-Shirt",
            newText: "تيشيرت دريملاند",
        },
        {
            originalText: "Dreamland Pants",
            newText: "سروال دريملاند",
        },
        {
            originalText: "Cuddly Gloves",
            newText: "قفازات كادلي",
        },
        {
            originalText: "Dreamy Bonnet",
            newText: "قبعة دريمي",
        },
        {
            originalText: "Homey Robe",
            newText: "ثوب هومي",
        },
        {
            originalText: "Cloud Bra",
            newText: "",
        },
        {
            originalText: "Sweet Dreams Mask",
            newText: "حمالة الصدر كلاود",
        },
        {
            originalText: "Months",
            newText: "أشهر",
        },
        {
            originalText: "1 Month",
            newText: "شهر",
        },
        {
            originalText: "Sold out",
            newText: "غير متوفر",
        },
    ];

    if (mode == "autoTranslate") {
        translationData.forEach(item => {
            const pathname = location.pathname;
            item.searchIn?.forEach(search => {
                if (
                    (search.matchFullPath && pathname === search.pathname) ||
                    (!search.matchFullPath && pathname.includes(search.pathname))
                ) {
                    const interval = setInterval(() => {
                        const elems$ = $(search.selector);
                        if (elems$) {
                            elems$.each((index, elem) => {
                                setTimeout(() => {
                                    search.shouldClearInterval && clearInterval(interval);

                                    let finalHTML;
                                    if (search.fullReplace) {
                                        finalHTML = item.newText;
                                    } else {
                                        finalHTML = $(elem).html().replaceAll(item.originalText, item.newText);
                                    }
                                    $(elem).html(finalHTML);
                                }, 1)
                            });
                        }
                    }, 50);
                }
            })
        });
    } else if (mode == "returnValue") {
        let finalText = text;

        translationData.forEach(item => {
            if (text.toLowerCase().includes(item.originalText.toLowerCase())) {
                finalText = finalText.replaceAll(item.originalText, item.newText);
            }
        });

        return finalText;
    }
}

localize();
